export default "__VITE_ASSET__9b6b655e__"